export const mcc_categories = [
    {
        lower: 1,
        upper: 1499,
        category: "Agricultural services"
    },
    {
        lower: 1500,
        upper: 2999,
        category: "Contracted services"
    },
    {
        lower: 3000,
        upper: 3299,
        category: "Airlines"
    },
    {
        lower: 3300,
        upper: 3499,
        category: "Car rental"
    },
    {
        lower: 3500,
        upper: 3999,
        category: "Lodging"
    },
    {
        lower: 4000,
        upper: 4799,
        category: "Transportation services"
    },
    
    {
        lower: 4800,
        upper: 4999,
        category: "Utility services"
    },
    {
        lower: 5000,
        upper: 5599,
        category: "Retail outlet services"
    },
    {
        lower: 5600,
        upper: 5699,
        category: "Clothing stores"
    },
    {
        lower: 5700,
        upper: 7299,
        category: "Miscellaneous stores"
    },
    {
        lower: 7300,
        upper: 7999,
        category: "Business services"
    },
    {
        lower: 8000,
        upper: 8999,
        category: "Professional services and membership organizations"
    },
    {
        lower: 9000,
        upper: 9999,
        category: "Government services"
    }
];
